import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = [
    'alert',
    'alertContainer',
    'info',
    'infoContainer',
    'notice',
    'noticeContainer',
    'serverFlashContainer'
  ];

  connect() {
    if (this.hasInfoTarget) {
      window.addEventListener('flashInfo', this.showInfo)
      window.addEventListener('closeFlashInfo', this.closeInfo);
    }
    if (this.hasAlertTarget) {
      window.addEventListener('flashAlert', this.showAlert)
      window.addEventListener('closeFlashAlert', this.closeAlert);
    }
    if (this.hasNoticeTarget) {
      window.addEventListener('flashNotice', this.showNotice)
      window.addEventListener('closeFlashNotice', this.closeNotice);
    }
  }

  disconnect() {
    window.removeEventListener('flashAlert', this.showAlert);
    window.removeEventListener('flashInfo', this.showInfo);
    window.removeEventListener('flashNotice', this.showNotice);
    window.removeEventListener('closeFlashAlert', this.closeAlert);
    window.removeEventListener('closeFlashInfo', this.closeInfo);
    window.removeEventListener('closeFlashNotice', this.closeNotice);
  }

  showAlert = event => {
    this.alertTarget.innerText = this.trimMessage(event?.detail?.message);
    this.alertContainerTarget.classList.remove('hidden');
  }

  showInfo = event => {
    this.infoTarget.innerText = this.trimMessage(event?.detail?.message);
    this.infoContainerTarget.classList.remove('hidden');
  }

  showNotice = event => {
    this.noticeTarget.innerText = this.trimMessage(event?.detail?.message);
    this.noticeContainerTarget.classList.remove('hidden');
  }

  closeAlert = () => {
    this.alertContainerTarget.classList.add('hidden');
  }

  closeInfo = () => {
    this.infoContainerTarget.classList.add('hidden');
  }

  closeNotice = () => {
    this.noticeContainerTarget.classList.add('hidden');
  }

  dismissServerFlash = () => {
    this.serverFlashContainerTargets.forEach(target => target.classList.add('hidden'));
  }

  trimMessage(message) {
    const max = 300;
    return message.length > max ? `${ message.substring(0, max - 3) }...` : message;
  }
}
